import type { ReactElement, ReactNode } from 'react';
import { Box, Flex } from '@mantine/core';

interface SideRailPageLayoutProps {
    /** The main content — the visualization, grid, or table (fills the remaining width). */
    children: ReactNode;
    /** The right rail — typically a vertical summary card with AI insights below it. Stacks under the content on narrow screens. */
    rail: ReactNode;
}

/**
 * The Behavior-style drill layout: main content on the left, a fixed-width
 * (300px) right rail on the right that stacks below the content on narrow
 * screens. Shared by the surface topic pages (`side-rail` drill style) and the
 * Spend › Cost screen so both read with the same summary-card-plus-insights rail.
 */
export default function SideRailPageLayout({ children, rail }: SideRailPageLayoutProps): ReactElement {
    return (
        <Flex gap="lg" align="flex-start" direction={{ base: 'column', lg: 'row' }}>
            <Box style={{ flex: 1, minWidth: 0, width: '100%' }}>{children}</Box>
            <Box style={{ width: 300, flexShrink: 0, maxWidth: '100%' }}>{rail}</Box>
        </Flex>
    );
}
